<template>
  <div class="box3">
    <div class="block" ref="block"></div>
    <pageTitle
      title="AI产品经理就业前景广阔"
      titleColor="#24375C"
    />
    <!-- <div class="topContent">
      <p>产品经理就业班课程</p>
      <p>
        覆盖需求调研、分析、管理及流程、结构和原型设计等产品<br />工作流程；掌握5大项目设计，胜任一线企业实际工作需求
      </p>
    </div> -->

    <div class="nav-box">
      <div class="nav"
        :class="{ 'cur-nav': navCur == index }" 
        v-for="(item, index) in navList" 
        :key="index"
        @click="changeNavCur(index)">
        <p>{{item.name}}</p>
      </div>
    </div>
    <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
      <swiper-slide
        class="swiperwrap"
        v-for="(item, index) in projectList"
        :key="index"
      >
        <div class="wrap">
          <img :src="item.imgUrl" />
        </div>
      </swiper-slide>
    </swiper>

    <div class="content">课程内容</div>
    <div class="box5-btm-box">
      <div class="box5-btm">
        <div
          class="subject-box"
          v-for="(item, index) in list"
          :key="index"
          ref="item"
          :style="{
            backgroundColor:
              cur == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" @click="changeCur(index)">
            <div class="title">
              <p>{{ item.stage }}</p>
              {{ item.nav }}
            </div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div
            class="course-content"
            :class="{ 'show-answer': cur == index && showAnswer }"
          >
            <div class="line"></div>
            <div class="title-icon">
              <img
                src="../../../assets/coursePage/pm/box3/icon1.png"
                alt
              />主要内容
            </div>
            <div class="main-content">
              <div class="main-text2" v-for="i in item.power" :key="i">
                {{ i }}
              </div>
            </div>

            <div class="title-icon">
              <img
                src="../../../assets/coursePage/pm/box3/icon2.png"
                alt
              />可掌握的核心能力
            </div>
            <div class="main-text">
              <div v-for="i in item.problem" :key="i">
                {{ i }}
              </div>
            </div>

            <!-- <div class="title-icon icon3">
              <img
                src="../../../assets/coursePage/pm/box3/icon3.png"
                alt
              />市场价值
            </div>
            <div class="main-text main-text2">
              <p>{{ item.into }}</p>
            </div> -->
          </div>
        </div>
      </div>

      <div class="btn" @click="openDetail">查看详细大纲</div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {},
  data() {
    let that = this;
    return {
      cur: 0,
      navCur: 0,
      navList: [{name: '招聘增速迅猛'},{name: '招聘行业广阔'},{name: '薪资待遇可观'}],
      swiperOption: {
        loop: true,
        slidesPerView: 1,
        on: {
          slideChangeTransitionStart: function () {
            that.navCur = this.realIndex;
          }
        },
      },
      projectList: [
        {imgUrl: require('../../../assets/coursePage/pm/box3/1.png')},
        {imgUrl: require('../../../assets/coursePage/pm/box3/2.png')},
        {imgUrl: require('../../../assets/coursePage/pm/box3/3.png')}
      ],
      list: [
        {
          stage: "阶段一",
          nav: "产品入门",
          power: [
            "全面讲解产品经理职责、分类、能力素质以及职业发展方向；",
            "以核心用户切入，阐述如何抓住核心用户、场景化分析、需求收集辨别和撰写用户故事；",
            "围绕需求分析-功能优先级划分-功能价值-用户体验贯穿讲解产品解决方案；",
            "概述项目立项，包括项目方案输出、可行性分析、产品规划和立项评审；",
          ],
          problem: [
            "建立对产品经理的认知，以便规划自己未来发展方向；",
            "掌握抓住核心用户和构建用户故事的方法；",
            "学会产品解决方案的思考和项目立项的全流程；",
          ],
          // into: "具备需求调研、需求分析及原型设计的能力，初级产品思维，标准工作流程，帮助企业改善工作混乱的现象，严格规范的评审需求，筛选需求，标准化执行产品规划和产品设计。",
        },
        {
          stage: "阶段二",
          nav: "内容项目实战",
          power: [
            "带你认识需求的本质，基于不同场景如何开展需求收集，并对需求池进行管理；",
            "详细讲解关于如何进行需求分析，包括需求澄清、需求真伪、需求优先级等；",
            "思路和技巧双管齐下，讲解如何绘制多种结构图和流程图；",
            "专业的产品设计思路教你如何使用Axure绘制产品原型；",
            "了解什么是产品需求说明、如何撰写产品需求说明；",
            "场景+产品推导带你进行内容产品的产品设计，包括用户端、自媒体端和平台端；",
            "讲解产品生产发布流程，包括如何与团队成员协作，如何进行项目管理以及需求评审等。",
          ],
          problem: [
            "具备需求收集和需求分析的能力；",
            "能够使用Processon和Axure进行流程图和原型绘制；",
            "掌握PRD文档的撰写；",
            "能够自主完成内容产品的设计，并具备自主设计能力；",
            "掌握产品从设计到发布上线的流程以及推动方式。",
          ],
          // into: "增强了学生独立思考内容，强化了产品思维及完整项目规划能力，可以进一步提升学生需求分析、产品设计能力。场景真实、完全模拟公司工作环境，提升学生项目经历真实性。",
        },
        {
          stage: "阶段三",
          nav: "电商项目实战",
          power: [
            "认识电商，包括电商的发展、电商三要素、电商运营模式等；",
            "拆解项目立项和立项说明书撰写，包括市场分析、产品架构、迭代计划；",
            "用户端的设计，如产品形态选择和设计思路，贯穿商品浏览-下单售后的全流程设计；",
            "电商后台的设计，包括商品中心、营销位管理、订单管理、售后管理、种草管理和财务管理等；",
            "分销电商和直播电商的搭建思路和产品设计。",
          ],
          problem: [
            "具备产品立项、规划、迭代制定能力；",
            "掌握Web/App/H5/小程序等产品形态的适用场景以及小程序的设计规范；",
            "能够独立完成电商商城、分销电商、直播电商等产品的设计。",
          ],
          // into: "增强了学生独立思考内容，强化了产品思维及完整项目规划能力，可以进一步提升学生需求分析、产品设计能力。场景真实、完全模拟公司工作环境，提升学生项目经历真实性。",
        },
        {
          stage: "阶段四",
          nav: "电商运营实战",
          power: [
            "基础运营知识讲解运营工作和营销中心核心功能；",
            "常见的单品活动和总价活动的产品设计，包括秒杀、预售、直降、折扣等；",
            "讲解常见的营销规则，如叠加&互斥、递进式&平行式、分摊规则等；",
            "讲解营销工具的产品设计，包括抽奖和优惠券等；",
            "店铺装修如何设计，思路讲解、常见组件、产品设计；",
            "用户精细化运营的思路和方法，包括用户画像、积分体系和会员体系等。",
          ],
          problem: [
            "掌握基础运营能力，包括方案制定、精细化运营策略等；",
            "能够设计相应的营销活动或工具解决产品/用户的运营问题；",
            "根据自身公司产品的情况匹配合适的营销规则进行设计。",
          ],
          // into: "具备产品设计和产品运营的双重能力，并能根据运营目标去实际落地产品设计；掌握当前热门的内容电商的玩法及对应的产品设计和运营。",
        },
        {
          stage: "阶段五",
          nav: "B端项目实战",
          power: [
            "B端基础知识，包括B端产品市场发展和分类、B端和C端产品差异等；",
            "CRM系统的核心要素、设计思路以及核心功能产品设计；",
            "讲解不同的CRM模式的特点和设计逻辑以及典型代表功能；",
            "供应链典型产品进销存系统的设计思路和核心功能产品设计；",
            "客服系统的结构构成和产品设计，包括智能客服、工单系统、质检系统等；",
            "SaaS产品特点和模式讲解，以及典型SaaS产品的设计思路。",
          ],
          problem: [
            "掌握B端产品的特点以及设计思路；",
            "掌握典型B端产品CRM、进销存和客服系统的产品设计；",
            "掌握SaaS类产品的设计。",
          ],
          // into: "具备数据后台及其他数据产品设计能力，可以通过数据赋能实现产品提升，满足市场上互联网公司对数据产品经理的岗位要求。",
        },
        {
          stage: "阶段六",
          nav: "数据分析",
          power: [
            "讲解用户增长，包括用户生命周期、用户增长模型以及用户增长策略施行；",
            "讲解数据分析流程以及如何搭建数据分析框架；",
            "讲解数据采集，包括采集类型、数据埋点方式、埋点流程以及埋点文档输出；",
            "数据处理的方法，包括数据清洗和数据加工；",
            "多种数据分析方法，包括对比、拆解以及预测方向的相应分析方法；",
            "数据呈现和数据报告撰写，如不同数据图表的应用，工具适用以及报告撰写。",
          ],
          problem: [
            "能够自行制定合适的用户增长策略；",
            "可以自行根据产品制定数据埋点收集需求；",
            "使用不同的数据分析方法对业务和产品进行分析；",
            "使用工具制作合适的数据图表，撰写数据分析报告。",
          ],
          // into: "具备B端后台产品的规划、设计能力，达到市场上互联网公司对后台产品经理的岗位要求。",
        },
        {
          stage: "阶段七",
          nav: "AI基础",
          power: [
            "AI大模型的本质、运行原理、发展阶段、局限性和安全性",
            "AI大模型的分类划分，了解不同大模型的特点",
            "AI产品的多层结构、发展趋势以及AI产品经理需求"
          ],
          problem: [
            "掌握AI大模型的运行原理，建立正确的AI产品认知",
            "了解AI产品划分和生态分布，为AI产品设计打下基础"
          ]
        },
        {
          stage: "阶段八",
          nav: "提示词工程",
          power: [
            "提示词和提示词工程的本质",
            "提示词的撰写原则和框架，Prompt的设计思路和方法",
            "提示词技术CoT、ToT、Step-Back等使用",
            "提示词工程的动态维护方法和模板库"
          ],
          problem: [
            "能够基于需求思考完成Prompt设计",
            "能够根据合适的场景使用CoT、ToT、Step-Back等技术完成提示词撰写",
            "能够基于个人和工作需要建立提示词维护方法"
          ]
        },
        {
          stage: "阶段九",
          nav: "正确使用AI产品的方法",
          power: [
            "使用AI产品的思维模型，学习AI协作任务流程方法",
            "如何使用AI辅助收集产品需求",
            "如何使用AI辅助分析产品需求",
            "如何使用AI辅助完成产品方案设计"
          ],
          problem: [
            "能够根据任务需要，使用多种AI产品组合解决问题",
            "学会能够使用AI辅助收集产品需求、分析需求以及完成产品方案设计"
          ]
        },
        {
          stage: "阶段十",
          nav: "基于大模型设计AI产品",
          power: [
            "从不同维度分析AI产品需求，做业务需求拆解同时定义验收标准",
            "模型能力验证的必要性、验证方法和流程，并确定判断维度",
            "AI 大模型API的参数拆解、参数模板和核心参数的产品逻辑",
            "阅读AI大模型的API文档的方法",
            "API常见问题、产品对策，以及接入需求说明"
          ],
          problem: [
            "能够根据需求理解，确定大模型API参数设定",
            "具备阅读大模型API文档的能力",
            "学会如何基于大模型API接入设计AI产品并完成相关需求说明",
            "明确大模型API常见问题与产品对策"
          ]
        },
        {
          stage: "阶段十一",
          nav: "智能体设计",
          power: [
            "大模型Agent的基础认知，包括Agent本质、Function Call、MCP、RAG等本质和原理",
            "基于知识库搭建问答助手Agent",
            "基于工具调用和数据处理搭建旅游规划Agent",
            "基于对话流设计智能面试官Agent",
            "使用多智能体设计Agent",
            "结合Coze设计AI旅游行Agent"
          ],
          problem: [
            "理解大模型Agent的原理组成和搭建方法",
            "能够运用不同需求场景，搭建设计相匹配的Agent解决问题"
          ]
        },
        {
          stage: "阶段十二",
          nav: "就业指导",
          power: [
            "1V1作品指导；",
            "简历撰写指导，批阅修改简历；",
            "1V1模拟面试，真实面试预演练；",
            "面试辅导，包括简历投递技巧、面试准备、面试应对和面试复盘；",
            "辅导入职工作初适应。",
          ],
          problem: [
            "学会如何撰写简历；",
            "能够应对面试的问题；",
            "找到合适的工作顺利上岗就业。",
          ],
          // into: "互联网医疗、智慧城市、社交平台、金融等行业目前的市场上缺少大量优秀产品经理，该课程通过对相关行业的产品设计思想及业务剖析，能够让学生胜任不同行业产品的PM。",
        },
      ],
      list1: [
        {
          title: "完成项目-简历-面试-入职",
          text: "面试就业阶段",
          num: "20",
        },
        {
          title: "学会设计CDP为代表的数据产品，包括数据指标体系、数据处理、数据营销产品等",
          text: "数据产品阶段",
          num: "18",
        },
        {
          title: "掌握完整的数据分析流程",
          text: "数据分析阶段",
          num: "18",
        },
        {
          title: "学会对CRM、进销存、SaaS等B端产品设计",
          text: "B端实战阶段",
          num: "16",
        },
        {
          title: "建立运营体系，运用多种营销工具完成营销<br/>目的",
          text: "电商运营阶段",
          num: "15",
        },
        {
          title: "认知电商产品，搭建完整的电商系统",
          text: "电商实战阶段",
          num: "12",
        },
        {
          title: "运用专业，全流程完成内容项目设计",
          text: "内容实战阶段",
          num: "10",
        },
        {
          title: "建立产品经理初步认知",
          text: "产品入门阶段",
          num: "8",
        },
      ],
      cur: -1,
      showAnswer: true,
      prevItemHeight: 0,
    };
  },
  methods: {
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
        this.clickZiXun()
      }
      this.mai("产品经理-就业课","查看详细大纲",0,null)
    },
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      this.goTop(index);
    },
    changeNavCur(index) {
      this.swiper.slideTo(index + 1, 0, false);
      this.navCur = index;
    },
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
  },
};
</script>

<style lang="less" scoped>
.box3 {
  width: 100%;
  background: url("../../../assets/coursePage/pm/box3/bgc.png") no-repeat;
  background-size: cover;
  .block {
    height: 80px;
  }
  .topContent {
    background: url("../../../assets/coursePage/pm/box3/topContent.png")
      no-repeat;
    width: 730px;
    height: 232px;
    margin: 28px auto 0;
    text-align: center;
    overflow: hidden;
    background-size: cover;
    p:nth-child(1) {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #5f59ff;
      line-height: 48px;
      margin: 48px 0 6px;
    }
    p:nth-child(2) {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 40px;
    }
  }
  
  .nav-box {
    padding: 0 32px;
    margin-top: 48px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .nav {
      p {
        width: 224px;
        height: 72px;
        border-radius: 38px;
        font-size: 28px;
        line-height: 72px;
        color: #1D2129;
        text-align: center;
        font-weight: bold;
        margin: 0 auto;
      }
      
    }
    .cur-nav {
      p {
        background: #FFFFFF;
        box-shadow: 0px 8px 20px 0px rgba(0,0,0,0.05);
        border: 2px solid #FFFFFF;
      }
    }
  }
  .swiperitems {
	  margin: 24px auto;
    .wrap {
      width: 686px;
      margin: 0 auto;
      img {
        box-sizing: border-box;
        width: 686px;
        background: rgba(255,255,255,0.5);
        box-shadow: 8px 16px 60px 0px rgba(0,0,0,0.05);
        border-radius: 20px;
        border: 4px solid #FFFFFF;
        backdrop-filter: blur(10px);
      }
    }
  }

  .exp {
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #827cb0;
    line-height: 28px;
    margin: 0px 0 80px;
    text-align: center;
  }
  .content {
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #5f59ff;
    line-height: 44px;
    background: url("../../../assets/coursePage/pm/box3/content.png") no-repeat;
    width: 184px;
    height: 68px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 48px;
    background-size: cover;
    margin-top: 44px;
  }
  .box5-btm-box {
    padding-bottom: 88px;
    width: 100%;
  }
  .btn {
    margin: 0 auto;
    margin-top: 60px;
    width: 686px;
    height: 96px;
    background-image: linear-gradient(90deg, #3363fc 0%, #9b97ff 100%);
    box-shadow: 0px 0px 20px 0px #e6eef5;
    border-radius: 48px;
    text-align: center;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 2px;
    color: #ffffff;
    line-height: 96px;
  }
  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    border-radius: 16px;
  }
  .subject-box:nth-child(2) {
    .main-content {
      .main-text2 {
        p {
          text-indent: -13px;
          padding-left: 13px;
        }
      }
    }
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 22px 0px 22px 35px;
    padding-right: 22px;
    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;
    justify-content: space-between;

    .title {
      margin-right: 20px;

      display: flex;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #020941;
      line-height: 40px;
      p {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 600;
        line-height: 40px;
        color: #5f59ff;
        margin-right: 16px;
      }
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      margin-right: 5px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    padding: 0px 24px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    transition: 0.3s ease all;
    overflow: hidden;
    z-index: 3;
    padding: 0px 40px 0px;
    .line {
      margin-bottom: 28px;
      width: 622px;
      height: 1px;
      margin-left: -8px;
      background: #F2F3F5;
    }
  }

  .show-answer {
    padding: 0px 40px 0px;
    border-radius: 16px;
    // display: block;
    max-height: 1600px;
    opacity: 1;
    transition: 0.4s ease all;
  }

  .title-icon {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    height: 44px;
    font-size: 28px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #1d2129;
    img {
      margin-right: 14px;
      width: 32px;
      height: 32px;
    }
  }

  .main-content {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 4px;
  }
  .main-content .main-text2:last-child {
    p {
      &::before {
        display: none;
      }
    }
  }
  .main-text {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #66666c;
    line-height: 40px;
    margin-top: 4px;
    margin-bottom: 40px;
    margin-left: 45px;
    div {
      line-height: 40px;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background: #86909c;
        position: absolute;
        left: -22px;
        top: 18px;
        border-radius: 50%;
      }
    }
  }
  .main-text2 {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #66666c;

    width: 100%;
    margin-bottom: 5px;
    margin-left: 45px;

    line-height: 40px;
    position: relative;
    &::before {
      content: "";
      display: block;
      width: 4px;
      height: 4px;
      background: #86909c;
      position: absolute;
      left: -22px;
      top: 18px;
      border-radius: 50%;
    }
  }
  .main-text3 {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #66666c;
    line-height: 40px;
    padding-bottom: 32px;
    margin-top: 4px;
    margin-left: 45px;
  }
}
</style>
